/* tslint:disable */
import { GenProvider } from 'providers/gen/gen';
import { Router } from '@angular/router';
import { Injectable, EventEmitter } from '@angular/core';
import { ConfigProvider } from 'providers/config/config';
import { ServiceProvider } from '../../providers/service/service';


@Injectable()
export class AuthService {

  login: any;

  private usuarioAutenticado: boolean = false;

  mostrarMenuEmitter = new EventEmitter<boolean>();

  constructor(
    private genProvider: GenProvider,
    public configProvider: ConfigProvider,
    private router: Router,
    private serviceProvider:ServiceProvider)
     {

      }

  fazerLogin(usuario){
      this.genProvider.onGetfilter('login', 'login', usuario.nome.toLowerCase()).subscribe(data =>{
        this.login = JSON.parse(JSON.stringify(data));
        if (this.login.length > 0) {
          if (this.login[0].senha == usuario.senha) {
            // atualiza dados de configuracao do sistem
              this.configProvider.setConfigData(usuario.nome.toLowerCase(), usuario.senha)
              this.genProvider.onParametros(this.login[0])
              this.usuarioAutenticado = true;
              this.mostrarMenuEmitter.emit(true);
            //  this.router.navigate(['/dashboard']);
              this.router.navigate(['']);
            }
          else {
            alert('Senha incorreta, tente novamente!');
            this.usuarioAutenticado = false;
            this.mostrarMenuEmitter.emit(false);
              }
        }else{
            alert('Nome de Usuário incorreto, tente novamente!');
            this.usuarioAutenticado = false;
            this.mostrarMenuEmitter.emit(false);
        }
       },
       err => {
        console.log(err)
        alert('Erro ao acessar o servidor, tente novamente!');
        this.usuarioAutenticado = false;
        this.mostrarMenuEmitter.emit(false);

      }
    )

  }
usuarioEstaAutenticado(){
  return this.usuarioAutenticado;
}
notificacao(){
  let msg = "*Plataforma Disque Denúncia.*" + this.serviceProvider.ctrl + "LOGIN DE INICIALIZAÇÃO"
    let formulario = {
    contato: '559193026224',
    mensagem: msg
  };
  setTimeout(() => {
    this.serviceProvider.enviarMsg(formulario);
  }, 5000);
}
}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/login/auth.service.ts